import {version} from '../package.json'

export const config = {
    mantainance: false,
    bundle: "shop.progetto.capricci",
    version: "2.2.4",
    refreshTokenAdvance: 300, //seconds before expire
    apiKey: "4da54a3b-e769-11ee-9f6e-96000211878b",
    baseurl: "https://capricci-api.progetto.shop",
    defaultLanguage: { code: "it", label: "Italian" },
    languages: [
        { code: "gb", label: "English" },
        { code: "it", label: "Italian" },
    ],
    tab_channel: {
        device: "shop.progetto.capricci/device",
        mainTab: "shop.progetto.capricci/main-tab"
    },
    push_notification: {
        enabled: false,
        apiKey: "xxx",
        config: {  // WARNING: Remember to copy this params in /public/firebase-messaging-sw.js
            apiKey: "...",
            authDomain: "...",
            projectId: "...",
            storageBucket: "...",
            messagingSenderId: "...",
            appId: "...",
            measurementId: "..."
        }
    },
    restError: {
        BadRequest: "1000",
        PreconditionFailed: "6000",
        Forbidden: "8000",
    }
};